<template>
  <div class="container">
    <div class="hasData" v-if="list != null && list.length > 0">
      <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getListHandle"
      >
        <div v-for="(item, index) in list" :key="index">
          <div class="l_like">
            <!-- 1文章 2视频 6动态 7动态视频-->
            <div>
              {{ item.NickName }}于{{ item.CreateTimeStr }}点赞了我的{{
                item.ContentType == 1
                  ? "文章"
                  : item.ContentType == 2
                  ? "视频"
                  : "动态"
              }}
            </div>
            <div
              class="li_view"
              @click="toDetail(item.ContentType, item.ContentId, item.MemberId)"
            >
              <div v-if="item.Thumbnail">
                <img
                  src="../../../static/images/icon/paly2.png"
                  class="playIcon"
                  v-if="item.ContentType == 2 || item.ContentType == 7"
                />
                <van-image fit="cover" :src="item.Thumbnail" />
              </div>
              <div class="overFlowTwo">{{ item.Content }}</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="noDataBox" v-else>
      <span class="iconfont icon-kong"></span>
      <div>什么也没有！</div>
    </div>
  </div>
</template>
<script>
import { memberLikeMsgList } from "@/api/member";
import { List, Image } from "vant";
export default {
  name: "myLike",
  components: {
    "van-list": List,
    "van-image": Image,
  },
  data() {
    return {
      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
      list: [],
    };
  },
  methods: {
    //进入详情
    toDetail(type, id, mid) {
      if (type == 1) {
        //文章
        this.$router.push({
          path: "/articleDetail",
          query: { id: id, mid: mid },
        });
      } else if (type == 2) {
        //视频
        this.$router.push({
          path: "/videoDetail",
          query: { id: id, mid: mid },
        });
      } else if (type == 6) {
        //图文动态
        this.$router.push({
          path: "/trendDetails",
          query: { tid: id },
        });
      } else if (type == 7) {
        //视频动态
        this.$router.push({
          path: "/videoDetails",
          query: { vid: id },
        });
      } else {
      }
    },

    //获取动态列表
    getListHandle() {
      var that = this;
      var data = {
        Page: {
          PageIndex: that.pageIndex,
          PageSize: 20,
        },
      };
      memberLikeMsgList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          // 加载状态结束
          that.loading = false;
          // 数据全部加载完成
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },
  },
  mounted() {
    this.getListHandle();
  },
};
</script>
<style lang="less" scoped>
.container {
  padding: 0 20px 20px 20px;
  box-sizing: border-box;
  .l_like {
    color: #999;
    font-size: 11px;
    margin-top: 25px;
    line-height: 18px;
    .li_view {
      background: #f1f1f1;
      color: #333;
      font-size: 12px;
      position: relative;
      display: flex;
      align-items: center;
      margin-top: 3px;
      .van-image {
        width: 75px;
        height: 50px;
        display: block;
        margin-right: 15px;
      }
      .playIcon {
        position: absolute;
        z-index: 2;
        bottom: 4px;
        left: 3px;
        width: 17px;
        height: 17px;
      }
    }
  }
}
</style>

